import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0502 from "../../../lesson/course-05/lesson-02/lesson";
import lesson0505 from "../../../lesson/course-05/lesson-05/lesson";
import lesson0506 from "../../../lesson/course-05/lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "1fae7597-0318-44df-a6fc-6f021556f389",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0502),
    lesson: lesson0502,
  },
  {
    id: "324f32cf-8a9b-49f9-b00a-2157344540c3",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0505),
    lesson: lesson0505,
  },
  {
    id: "45634582-e38c-4d12-a540-765f16d86270",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
];

export default lessonLinks;
